const features = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20breaking%20news%20scene%20with%20glowing%20headlines%20floating%20in%20dark%20space%2C%20warm%20crimson%20and%20gold%20accents%2C%20modern%20digital%20newsroom%20aesthetic%2C%20professional%20editorial%20design%2C%20mysterious%20atmosphere&width=800&height=500&seq=carousel-01-911&orientation=landscape',
    tag: '本月专题',
    title: '2026年夏季娱乐圈全盘点',
    summary: '从六月到八月，娱乐圈发生了哪些值得关注的重大事件？本文为你梳理夏季最全吃瓜时间线。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20collage%20of%20social%20media%20screens%20floating%20in%20a%20dark%20digital%20space%2C%20warm%20highlight%20effects%2C%20trending%20topics%20visualization%2C%20modern%20media%20monitoring%20concept%2C%20professional%20design&width=800&height=500&seq=carousel-02-911&orientation=landscape',
    tag: '深度调查',
    title: '直播电商行业乱象深度调查报告',
    summary: '从选品到售后，我们深入调查了直播电商行业的各个环节，揭开那些不为人知的行业内幕。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20figure%20silhouette%20against%20a%20bright%20stage%20backdrop%2C%20dramatic%20backlighting%2C%20entertainment%20industry%20concept%2C%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20professional%20photography&width=800&height=500&seq=carousel-03-911&orientation=landscape',
    tag: '独家揭秘',
    title: '选秀节目背后不为人知的资本游戏',
    summary: '一档选秀综艺从筹备到播出的背后，隐藏着怎样的资本运作逻辑？深度起底选秀产业链。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20vintage%20newspapers%20and%20modern%20digital%20screens%20blending%20together%2C%20warm%20sepia%20and%20crimson%20tones%2C%20news%20archive%20concept%2C%20editorial%20aesthetic%2C%20sophisticated%20design&width=800&height=500&seq=carousel-04-911&orientation=landscape',
    tag: '年度回顾',
    title: '2026上半年十大反转事件合集',
    summary: '有些爆料一开始人人都信，后来却出现惊天反转。回顾上半年最具戏剧性的十大反转事件。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20digital%20network%20of%20interconnected%20nodes%20glowing%20in%20warm%20colors%2C%20representing%20information%20flow%2C%20dark%20background%2C%20futuristic%20data%20visualization%2C%20professional%20and%20clean%20design&width=800&height=500&seq=carousel-05-911&orientation=landscape',
    tag: '人物专题',
    title: '从素人到顶流：年度最具话题网红成长史',
    summary: '他们是如何从默默无闻到全网皆知的？深度剖析2026年最受关注的几位网红走红路径。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20courtroom%20scene%20with%20warm%20dramatic%20lighting%2C%20legal%20documents%20scattered%2C%20tense%20atmosphere%2C%20cinematographic%20composition%2C%20dark%20wood%20tones%2C%20professional%20legal%20drama%20aesthetic&width=800&height=500&seq=carousel-06-911&orientation=landscape',
    tag: '法律视角',
    title: '网络爆料的法律边界：哪些瓜能吃哪些不能碰',
    summary: '在享受吃瓜乐趣的同时，我们也需要了解网络爆料信息传播的法律红线在哪里。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              焦点<span className="text-primary-500">专题</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              深度策划 · 全面呈现911吃瓜黑料最新合集与专题报道
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map((item, idx) => (
              <article
                key={idx}
                className="bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors duration-200 group"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-bold bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold text-foreground-950 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}